import React from "react"

class SegmentedControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.value || this.props.defaultValue || 0
    };
  }

  render() {
    return (
      React.createElement("div",
        {className: 'segmented-control ' + this.props.className || ''},
        this.props.children.map(function(child, index) {
          var selected = (child.props || {}).value === this.state.selected ||
            index === this.state.selected;
          return (
            React.createElement("div", {
                className: 'label' + (selected ? ' selected' : ''),
                key: "sc-" + this.props.name + index},
              React.createElement("input", {
                type: "radio",
                name: "sc-" + this.props.name,
                id: "sc-" + this.props.name + index,
                value: (child.props || {}).value || index,
                checked: selected,
                onChange: this.handleChange.bind(this)}),
              React.createElement("label", {
                  htmlFor: "sc-" + this.props.name + index},
                child)
            )
          );
        }.bind(this))
      )
    );
  }

  handleChange(e) {
    var index = e.currentTarget.value;
    if (this.props.onChange) {
      this.props.onChange(index);
    }
    else {
      this.setState({
        selected: index
      });
    }
  }

  componentDidMount() {
    if (!this.props.defaultValue && this.props.onChange) {
      this.props.onChange(this.state.selected);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value || nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({selected: nextProps.value || nextProps.defaultValue});
    }
  }
}
export default SegmentedControl
